module.exports = __webpack_public_path__ + "static/media/background_polk.83f87d3c.png";